// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__3o17A","control":"Checkout_control__9Oux5","actions":"Checkout_actions__3Qu_L","submit":"Checkout_submit__3bWnH","invalid":"Checkout_invalid__Y5oUq"};